exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body{margin:0;padding:0}.vh100{height:100vh}.vhc100{height:calc(100vh - 45px)}.w100p{width:100%}.p0{padding:0!important}.p20{padding:20px}.plr40{padding-left:40px;padding-right:40px}.mt-5{margin-top:5px}.mt-10{margin-top:10px}.mt-15{margin-top:15px}.mt-20{margin-top:20px}.calling{background:#efefef;position:fixed;bottom:31px;left:0;right:0;z-index:99;padding:5px;border-top:1px solid #dcdcdc}.object-fit-cover{object-fit:cover}.overflow-auto{overflow:auto}.tbl-btn{padding:0 7px;height:auto;background:transparent;border:none;font-size:13px;outline:none;cursor:pointer;&:hover{i{color:blue}}}.modal-common{width:700px;max-width:1000px}.info-list-modal{width:500px;max-width:1000px}.row-hover:hover{background:#f4f4f4}.zipcode-assignment-tag-picker .ms-BasePicker-input{width:95px}.text-center{text-align:center}.text-right{text-align:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./client/stylesheets/main.css
// module id = 1242
// module chunks = 0